import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { Staff } from '../StaffList';
import useLocations from '../../../helperHooks/useLocations';
import useStaffRolesOptions from '../../../helperHooks/useStaffRolesOptions';
import MobileRowActions from '../../../components/datagridComponents/MobileRowActions';

export const MobileRowMainContent = ({ data }: { data: Staff }) => {
  const { locations: locationOptions } = useLocations();
  const { staffRolesOptions } = useStaffRolesOptions();
  const rowLocation = useMemo(
    () =>
      locationOptions?.find((location) => location.value === data.mainLocationId?.toString())
        ?.label,
    [locationOptions, data]
  );
  const rowRole = useMemo(
    () => staffRolesOptions?.find((role) => role.value === data.staffRoleId?.toString())?.label,
    [locationOptions, data]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body1" sx={{ marginBottom: '0.25rem', fontWeight: 600 }}>
          {data.name}
        </Typography>
        <Typography variant="body2">{rowLocation}</Typography>
        <Typography variant="body2">{rowRole}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
          width: '20%',
          marginRight: '-0.5rem',
        }}
      >
        <MobileRowActions objectId={data.id} />
      </Box>
    </Box>
  );
};

export default MobileRowMainContent;
